import { createFileRoute } from "@tanstack/react-router";
import { robotsMeta } from "@/lib/seo";
import { ConvocatoriaResponder } from "@/components/convocatoria/ConvocatoriaResponder";

export const Route = createFileRoute("/convocatoria")({
  validateSearch: (search) => ({ t: typeof search.t === "string" ? search.t : "" }),
  head: () => ({
    meta: [{ title: "Convocatoria — Improve Yourself" }, ...robotsMeta(false, false)],
  }),
  component: ConvocatoriaPage,
});

function ConvocatoriaPage() {
  const { t } = Route.useSearch();
  return (
    <main className="min-h-screen bg-[#FAF6F0] px-4 py-8 sm:py-12">
      <div className="mx-auto w-full max-w-md">
        <ConvocatoriaResponder token={t} />
      </div>
    </main>
  );
}
